import css from '../tpl-css/style-section-card-faq-kynorelle.js';
const html = `
<style>${css}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#FFFFFF"
  data-top-padding="true" data-bottom-padding="true" data-color="#003568"
  style="background-color: #ffffff; color: #003568; --text-color: #003568;">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div data-show-title="true" data-attribute="content-title" class="content-title" style="display: block;">
        <h2 style="text-align:center;"><span style="color:#242424;">EAQs</span></h2>
        <p style="text-align:center;"><span style="color:#6d6f74;">Still have questions ? Check here</span></p>
      </div>

      <div class="wrap-card">
        <div data-attribute="card-item-content" data-order="2" data-style-center-y="false" class="card-left"
          style="order: 2;">
          <div data-attribute="card-accordions" data-show-accordion="true" style="display: block;">
            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Is it comfortable enough for all-day wear?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>
                    Yes. The soft stretch fabric moves with your body and stays comfortable from morning to night
                    without pressure.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Does it stay in place or roll down?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>It stays in place. The high waist is designed to hold without rolling or constant adjusting.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Will it feel tight when sitting or moving?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>
                    No. The fabric adapts to your body, so it stays flexible whether you’re sitting, walking, or
                    relaxing.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Is the fabric breathable?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>
                    Yes. It’s lightweight and breathable, making it easy to wear for long hours without feeling heavy.
                  </p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Can I wear it outside of workouts?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>Absolutely. It’s designed for real life — not just the gym.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Will it lose shape after washing?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>No. The fabric is made to hold its shape and stay consistent after multiple washes.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Is it see-through?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>No. It’s designed to give you a clean, confident look for everyday wear.</p>
                </div>
              </div>
            </div>

            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Is it easy to style?</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content" style="">
                <div data-attribute="accordion-text" class="accordion-text">
                  <p>Yes. The minimal design makes it easy to pair with anything in your wardrobe.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-attribute="card-item-image" data-order="1" class="card-right" style="order: 1;">
          <div data-show-image="true" data-attribute="wrap-image" class="wrap-image" style="display: block;">
            <img data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e5c412b93c1486d8cfbf.png" alt="" />
          </div>
          <div data-show-video="false" data-attribute="wrap-video" class="wrap-video" style="display: none;">
            <video width="100%" height="auto" autoplay="" muted="" loop="" playsinline="">
              <source data-attribute="card-video" type="video/mp4" src="" />
            </video>
          </div>
        </div>
      </div>
      <div data-show-button="true" data-attribute="button" class="button" style="display: block;">
        <a data-attribute="card-btn" class="card-btn" href="#" data-radius="4" data-background="#003568"
          data-color="#ffffff"
          style="--color-btn: #ffffff; --background-btn: #003568; --border-radius-btn: 4px; border-radius: 4px;">
          <span data-attribute="btn-text">SHOP NOW</span>
          <div class="icon-btn">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0L3.51 4.78636L0 9.57273H2.34L5.85 4.78636L2.34 0H0Z" fill="currentColor"></path>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>

`;
export default html;
